module.exports = __webpack_public_path__ + "67c1dcf088d77604e60fd1b8551ca368.pdf";